<template>
  <div class="container flex flex-direction">
    <dv-loading v-if="loading" class="loading">Loading...</dv-loading>
    <div class="page-title self-center">会员管理数据大屏</div>
    <div class="padding flex flex-direction padding-top-0">
      <div :class="{iloading:loading}" class="content-container flex align-center justify-between">
        <div class="number-item flex align-center">
          <div class="title">单位会员数量</div>
          <dv-digital-flop v-for="(item,index) in `${count_team}`.padStart(4,'0')" :key="index"
                           :config="{style:style,number:[Number(item)],content:'{nt}'}"
                           class="number"/>

          <div class="title margin-left-xs">家</div>
        </div>
        <div class="number-item flex align-center">
          <div class="title">个人会员数量</div>
          <dv-digital-flop v-for="(item,index) in `${count_personal}`.padStart(4,'0')" :key="index"
                           :config="{style:style,number:[Number(item)],content:'{nt}'}"
                           class="number"/>
          <div class="title margin-left-xs">人</div>
        </div>
        <div class="number-item flex align-center">
          <div class="title">会员服务场数</div>
          <dv-digital-flop v-for="(item,index) in `${count_services}`.padStart(4,'0')" :key="index"
                           :config="{style:style,number:[Number(item)],content:'{nt}'}"
                           class="number"/>
          <div class="title margin-left-xs">场</div>
        </div>
        <div class="number-item flex align-center">
          <div class="title">会员服务人次</div>
          <dv-digital-flop v-for="(item,index) in `${count_services_people}`.padStart(4,'0')" :key="index"
                           :config="{style:style,number:[Number(item)],content:'{nt}'}"
                           class="number"/>
          <div class="title margin-left-xs">人</div>
        </div>
      </div>
      <div class="flex ">
        <div :class="{iloading:loading}" class="content-container basis-personal min-sub">
          <div class="flex align-center justify-between">
            <div class="title">个人会员</div>
            <div class="more" @click="personalDialogVisible = true">更多<i class="el-icon-arrow-right"></i>
            </div>
          </div>
          <div class="flex flex-wrap margin-top-xs">
            <div v-for="(item,index) in members" :key="index"
                 class="personal flex flex-direction align-center">
              <el-image :src="item.headImg" class="image flex-shrink" fit="scale-down"></el-image>
              <div class="name">{{ item.name }}</div>
              <el-tooltip class="item" effect="light" :content="item.company" placement="bottom">
                <div class="company ovHide padding-lr-xs">{{ item.company }}</div>
              </el-tooltip>
            </div>
          </div>
          <el-empty v-if="members.length === 0"></el-empty>
        </div>
        <dv-border-box-8 :class="{iloading:loading}" :dur="5" class="content-container basis-personal flex flex-direction flex-sub margin-left-sm" style="padding: 0">
          <el-empty v-if="services.length === 0"></el-empty>
          <div class="menus flex align-center">
            <div v-for="(item,index) in services.slice(0,Math.min(services.length,4))"
                 :key="index"
                 :class="{active:cur_sm === index}" class="menu flex align-center justify-center" @click="serviceMenuChange(index,item.id)">
              <img :src="require(`../assets/img/data/icon_data_server_${index +1}${cur_sm === index ? '':'_diss'}.png`)" class="icon">
              <div class="title">{{ item.title }}</div>
            </div>
          </div>
          <div class="flex align-start">
            <div v-if="services.length > 0" class="flex-sub service-container flex flex-wrap">
              <div v-for="(item) in services[cur_sm].server.slice(0,Math.min(services[cur_sm].server.length,6))" :key="item.id"
                   class="service-classify flex flex-direction margin-top-sm">
                <div class="name flex align-center">
                  <img class="tag" src="../assets/img/data/icon_data_tag.png">
                  <div class="name">{{ item.title }}</div>
                </div>
                <div class="number flex align-center margin-left margin-top-sm">
                  <dv-digital-flop :config="{style:style,number:`${item.count}`.padStart(3,'0')
                                    .split('').map(num=>{ return Number(num)}),content:'{nt}{nt}{nt}{nt}{nt}'}"
                                   style="width: 105px"/>
                  <span>次</span>
                </div>
                <dv-decoration-2 style="width:100%;height:5px;"/>
              </div>
            </div>
            <div class="flex-sub service-container" v-if="services.length > 0">
              <div class="flex align-center justify-between">
                <div class="title">服务内容</div>
                <div class="more" @click="serviceDialogVisible = true">更多<i class="el-icon-arrow-right"></i></div>
              </div>
              <div class="flex flex-direction margin-top">
                <div v-for="(item,index) in scontents" :key="index" class="content"
                     @click="onServiceContentItem(item)">
                  {{ item.server_title }}
                </div>
                <el-empty v-if="scontents.length === 0"></el-empty>
              </div>
            </div>
          </div>
        </dv-border-box-8>
      </div>
      <div class="flex margin-top-sm justify-between">
        <div :class="{iloading:loading}" class="content-container basis-team min-sub">
          <div class="flex align-center justify-between">
            <div class="title">单位会员</div>
            <div class="more" @click="teamDialogVisible = true">更多<i class="el-icon-arrow-right"></i></div>
          </div>
          <div class="flex flex-wrap margin-top-xs">
            <div v-for="(item,index) in teams"
                 :key="index" class="team flex flex-direction align-center justify-center">
              <el-image :src="item.headImg" class="image"></el-image>
              <div class="company">{{ item.company }}</div>
            </div>
          </div>
          <el-empty v-if="teams.length === 0"></el-empty>
        </div>
        <div :class="{iloading:loading}" class="content-container basis-team flex-sub margin-left-sm">
          <div class="flex align-center justify-between">
            <div class="title">会员管理制度</div>
            <div class="more" @click="managementDialogVisible = true">更多<i class="el-icon-arrow-right"></i>
            </div>
          </div>
          <div class="flex flex-direction margin-top-xs">
            <div v-for="(item,index) in managements" :key="index" class="collapse flex flex-direction">
              <div class="title-container flex align-center justify-between"
                   @click="managementChange(index)">
                <div class="title">{{ item.typeName }}</div>
                <i :class="item.expand ? 'el-icon-arrow-down' : 'el-icon-arrow-up'" class="arrow"></i>
              </div>
              <div v-if="item.expand" class="flex flex-direction ">
                <div v-for="(child,position) in item.list.slice(0,Math.min(item.list.length,2))"
                     :key="position" class="content" @click="onItem(child)">
                  {{ child.title }}
                </div>
                <div v-if="item.list.length > 0" class="more">...</div>
                <div v-else class="more margin-top-sm self-center">暂无数据</div>
              </div>
            </div>
            <el-empty v-if="managements.length === 0"></el-empty>
          </div>
        </div>
        <div :class="{iloading:loading}" class="content-container basis-team  flex-sub margin-left-sm">
          <div class="flex align-center justify-between">
            <div class="title">会员入会流程</div>
            <div class="more" @click="joinDetailDialogVisible = true">更多<i class="el-icon-arrow-right"></i>
            </div>
          </div>
          <div class="flex-sub flex flex-direction">
            <div v-if="join.desc">
              <div class="flex-sub">
                <div class="desc">
                  {{ join.desc }}
                </div>
              </div>
              <!--                           <el-button class="more" @click="joinDetailDialogVisible = true">查看更多</el-button>-->
            </div>
            <el-empty v-else></el-empty>
          </div>
        </div>
      </div>
    </div>

    <more-personal-dialog :apply-dialog-visible="personalDialogVisible" :oid="oid" @watchState="watchState"></more-personal-dialog>
    <more-team-dialog :apply-dialog-visible="teamDialogVisible" :oid="oid" @watchState="watchState"></more-team-dialog>
    <more-management-dialog :apply-dialog-visible="managementDialogVisible" :oid="oid" @watchState="watchState"></more-management-dialog>
    <more-management-detail-dialog :id="cur_id"
                                   :apply-dialog-visible="managementDetailDialogVisible" :title="cur_title" @watchState="watchState">
    </more-management-detail-dialog>
    <more-join-detail-dialog :apply-dialog-visible="joinDetailDialogVisible" :content="join.content" @watchState="watchState"></more-join-detail-dialog>
    <more-service-dialog :oid="oid" :id="cur_sm_id" :apply-dialog-visible="serviceDialogVisible" @watchState="watchState"></more-service-dialog>
    <more-service-detail-dialog :id="cur_id" :apply-dialog-visible="serviceDetailDialogVisible" @watchState="watchState"></more-service-detail-dialog>
  </div>

</template>

<script>

import MoreTeamDialog from "../components/data/MoreTeamDialog";
import MorePersonalDialog from "../components/data/MorePersonalDialog";
import MoreServiceDialog from "../components/data/MoreServiceDialog";
import MoreManagementDialog from "../components/data/MoreManagementDialog";
import MoreManagementDetailDialog from "../components/data/MoreManagementDetailDialog";
import MoreJoinDetailDialog from "../components/data/MoreJoinDetailDialog";
import {
  getJoinProcessDetail,
  getMemberCount,
  getMemberList,
  getMemberManagement,
  getMemberServiceContents,
  getMemberServices
} from "@/api/data";
import {formatHtml} from "@/utils/utils";
import MoreServiceDetailDialog from "../components/data/MoreServiceDetailDialog";

export default {
  name: "digitalize",
  data() {
    return {
      oid: this.$store.state.user.mid,
      loading: false,
      style: {
        fontSize: 36,
        fill: '#0ddaff',
        fontFamily: 'PingFang SC',
        fontWeight: 'bold'
      },
      members: [],
      teams: [],
      count_personal: 0,
      count_services: 0,
      count_services_people: 0,
      count_team: 0,
      managements: [],
      join: {
        content: '',
        desc: ''
      },
      services: [],
      cur_sm: 0,
      cur_sm_id: 0,
      scontents: [],
      personalDialogVisible: false,
      teamDialogVisible: false,
      managementDialogVisible: false,
      cur_id: 0,
      cur_title: '',
      managementDetailDialogVisible: false,
      joinDetailDialogVisible: false,
      serviceDialogVisible: false,
      serviceDetailDialogVisible: false
    }
  },
  created() {
    this.init()
  },
  mounted() {

  },
  components: {
    MoreServiceDetailDialog,
    MoreJoinDetailDialog,
    MoreManagementDetailDialog, MoreManagementDialog, MoreServiceDialog, MorePersonalDialog, MoreTeamDialog
  },
  methods: {
    async init() {
      this.loading = true
      let _data = await getMemberList(this.oid, 2, 1, 6)
      this.members = _data.data
      _data = await getMemberList(this.oid, 1, 1, 4)
      this.teams = _data.data
      _data = await getMemberCount(this.oid, '')
      this.count_personal = _data.data.count_personal
      this.count_services = _data.data.count_services
      this.count_services_people = _data.data.count_services_people
      this.count_team = _data.data.count_team
      _data = await getMemberManagement(this.oid, 1, 5)
      _data.data.map((item, index) => {
        item.expand = index === 0
      })
      this.managements = _data.data
      _data = await getJoinProcessDetail(this.oid, '')
      if (_data.status === 200){
        this.join = {
          content: _data.data.content,
          desc: formatHtml(_data.data.content)
        }
      }
      _data = await getMemberServices(this.oid)
      this.services = _data.data
      this.cur_sm_id = _data.data.length > 0 ? _data.data [0].id : 0
      await this.getServiceContents()
      this.loading = false
    },
    async getServiceContents() {
      if (!this.cur_sm_id) return
      let _data = await getMemberServiceContents(this.oid, this.cur_sm_id, 1, 5)
      this.scontents = _data.data
    },
    async serviceMenuChange(index, id) {
      this.cur_sm = index
      this.cur_sm_id = id
      await this.getServiceContents()
    },
    managementChange(position) {
      this.managements.map((item, index) => {
        if (index === position) {
          item.expand = !item.expand
        } else {
          item.expand = index === position
        }
      })
    },
    onItem(item) {
      this.cur_id = item.id
      this.cur_title = item.title
      this.managementDetailDialogVisible = true
    },
    onServiceContentItem(item){
      this.cur_id = item.id
      this.serviceDetailDialogVisible = true
    },
    watchState() {
      this.personalDialogVisible = false
      this.teamDialogVisible = false
      this.managementDialogVisible = false
      this.managementDetailDialogVisible = false
      this.joinDetailDialogVisible = false
      this.serviceDialogVisible = false
      this.serviceDetailDialogVisible = false
    }
  },
  filters: {},
  watch: {},
}
</script>

<style lang="scss" scoped>
.container {
  background: url(../assets/img/data/bg_data.jpg) no-repeat top;
  background-size: 100% 100%;
  height: 1080px;
  width: 1920px;
  overflow: auto;

  .loading {
    color: #ffffff;
    position: fixed;
  }

  .page-title {
    font-size: 36px;
    line-height: 36px;
    color: #ffffff;
    margin-top: 15px;
  }

  .basis-personal {
    height: 490px;
  }

  .basis-team {
    height: 380px;
  }

  .content-container {
    background-color: #15235199;
    border-radius: 8px;
    padding: 20px;

    &.iloading {
      filter: blur(10px);
    }

    &.min-sub {
      width: 620px;
    }

    &.border {
      border: solid 2px #31458d;
    }

    .service-container {
      margin: 30px 25px;

      .service-classify {
        width: 48%;

        &:not(:nth-child(2n+1)) {
          margin-left: 2%;
        }

        .name {
          font-size: 20px;
          color: #ffffff;

          .tag {
            width: 28px;
            margin-right: 10px;
          }
        }

        .number {
          span {
            font-size: 20px;
            color: #00d5e9;
          }
        }
      }

      .title {
        padding: 0 17px;
        font-size: 18px;
        color: #0ddaff;
        position: relative;

        &:after {
          position: absolute;
          content: '';
          left: 0;
          top: 50%;
          transform: translateY(-50%);
          width: 5px;
          height: 21px;
          background-color: #0ddaff;
          border-radius: 3px;
        }
      }

      .content {
        height: 60px;
        line-height: 60px;
        font-size: 18px;
        color: #ffffff;
        border-bottom: 1px solid #30407e;
        border-top: 1px solid #30407e;
        cursor: pointer;
      }
    }

    .service-container + .service-container {
      border-left: 1px solid #2e448a;
      min-height: 383px;
      margin: 30px 0;
      padding: 0 25px;
    }

    .menus {
      height: 71px;

      .menu {
        width: 25%;
        height: 100%;
        border-bottom: 1px solid #2e448a;
        border-right: 1px solid #2e448a;
        cursor: pointer;

        :nth-child(4) {
          border-right: 0 solid #2e448a;
        }

        &.active {
          border-bottom: 1px solid transparent;

          .title {
            color: #0ddaff;
          }
        }

        .icon {
          width: 20px;
        }

        .title {
          font-size: 20px;
          font-weight: bold;
          color: #ffffff;
          margin-left: 10px;
        }
      }
    }

    .desc {
      font-size: 16px;
      line-height: 32px;
      color: #d7dff6;
      text-align: justify;
      display: -webkit-box;
      -webkit-box-orient: vertical;
      -webkit-line-clamp: 9;
      overflow: hidden;
      word-break: break-all;
      margin-top: 20px;
    }

    //.more {
    //  display: block;
    //  ma
    //  height: 49px;
    //  background-color: transparent;
    //  border-radius: 8px;
    //  border: solid 1px #0ddaff;
    //  font-size: 18px;
    //  color: #0ddaff;
    //}

    .collapse {
      .title-container {
        height: 50px;
        border-bottom: 1px solid #30407e;
        margin-top: 10px;
        cursor: pointer;

        .title {
          padding: 0 17px;
          font-size: 18px;
          color: #0ddaff;
          position: relative;

          &:after {
            position: absolute;
            content: '';
            left: 0;
            top: 50%;
            transform: translateY(-50%);
            width: 5px;
            height: 21px;
            background-color: #0ddaff;
            border-radius: 3px;
          }
        }

        .arrow {
          color: #0ddaff;
        }
      }

      .content {
        font-size: 16px;
        color: #ffffff;
        cursor: pointer;
        margin-top: 13px;
      }

      .more {
        font-size: 16px;
        color: #ffffff;
      }
    }

    .team {
      width: 272px;
      height: 111px;
      background-color: #ffffff;
      border-radius: 6px;
      margin-top: 15px;

      &:not(:nth-child(2n+1)) {
        margin-left: 19px;
      }

      .image {
        width: 51px;
        height: 51px;
        border-radius: 51px;
      }

      .company {
        font-size: 16px;
        color: #333333;
        margin-top: 10px;
      }
    }

    .personal {
      width: 176px;
      height: 194px;
      background-color: #182c5b;
      border-radius: 6px;
      margin-top: 15px;

      &:not(:nth-child(3n+1)) {
        margin-left: 19px;
      }

      .image {
        width: 100%;
        height: 140px;
        border-radius: 6px 6px 0 0;
        background-color: #ffffff11;
      }

      .name {
        font-size: 16px;
        font-weight: bold;
        color: #ffffff;
        margin-top: 6px;
      }

      .company {
        font-size: 12px;
        color: #ffffff;
        margin-top: 6px;
        text-align: center;
        width: 100%;
      }
    }

    .title {
      font-size: 22px;
      color: #0ddaff;
      font-weight: bold;
    }

    .more {
      font-size: 18px;
      color: #ffffff;
      cursor: pointer;
    }

    .number-item {
      .title {
        font-size: 22px;
        color: #ffffff;
      }

      .number {
        width: 50px;
        height: 66px;
        border-radius: 4px;
        border: solid 2px #00f6ff33;
        margin-left: 10px;
      }
    }
  }

}
</style>
